import RoleVoter from './role-voter';

export default [new RoleVoter()];
